// extracted by mini-css-extract-plugin
module.exports = {"banner":"personal-plan-banner_banner__0DTHr","subtitle":"personal-plan-banner_subtitle__UJXCM"};